<template>
  <div class="mt-3">
    <h5 class="font-weight-light panel-header pl-3 py-2 w-100">{{ categoryName }}</h5>
    <div
      v-for="vp in items"
      class="col-sm-6 col-md-4 col-lg-4">
      <div class="row">
        <item-vat-pham :vatpham="vp"/>
      </div>

    </div>
    <infinite-loading
      :identifier="infiniteId"
      @infinite="infiniteHandler">
      <div slot="spinner">Đang tìm kiếm...</div>
      <div slot="no-more">Không còn sản phẩm nào!</div>
      <div slot="no-results">Không có sản phẩm nào phù hợp</div>
    </infinite-loading>
  </div>

</template>

<script>
  import {errorToaster} from "../../services/ErrorHandler";
  import rf from "../../communicate/RequestFactory";
  import ItemVatPham from "./ItemVatPham";
  import InfiniteLoading from "vue-infinite-loading";

  export default {
    name: "ItemCategory",
    components: {
      ItemVatPham,
      InfiniteLoading
    },
    props: ['id'],
    data: function () {
      return {
        items: [],
        categoryName: '',
        limit: 10,
        page: 1,
        infiniteId: +new Date(),
      }
    },
    mounted() {
      // this.loadData();
      this.infiniteId += 1;
    },
    methods: {
      infiniteHandler($state) {
        this.$Progress.start();
        const data = {
          id: this.id,
          page: this.page,
          limit: this.limit
        };
        rf.getRequest('CategoriesRequest').getItemInCategory(data).then((res) => {
          if (res.data) {
            this.categoryName = res.data.category;
            if (res.data.items && res.data.items.length) {
              this.page += 1;
              this.items.push(...res.data.items);
              $state.loaded();
            }else {
              $state.complete();
            }
            this.$Progress.finish();
          } else {
            this.$Progress.finish();
            $state.complete();
          }
        }).catch(err => {
          this.$Progress.fail();
          this.errors.push(err.message);
          $state.complete();
          errorToaster("Cố vấn Phong Thủy", "Xẩy ra lỗi kết nối");
        })
      },
      // loadData() {
      //   this.$Progress.start();
      //   rf.getRequest('CategoriesRequest').getItemInCategory(this.id).then((res) => {
      //     this.items = res.data.items;
      //     this.categoryName = res.data.category;
      //     this.$Progress.finish();
      //   }).catch(err => {
      //     infoToaster("Xảy ra lỗi", "Hệ thống đang bảo dưỡng");
      //     this.$Progress.fail();
      //   })
      // }
    }
  }
</script>

<style scoped>

  .panel-header {
    color: #fff ;
    background: #4189EB;
  }

</style>



// WEBPACK FOOTER //
// src/components/item/ItemCategory.vue